import useResizeObserver from '@react-hook/resize-observer';
import { RefObject, useState } from 'react';

/**
 * Uses resize obeserver to keep track of the height of the HTML element.
 * Primarily returns the block size (which includes the padding of an element)
 * If block size is not available then content rect height will be returned.
 */
export const useElementHeight = (ref: RefObject<HTMLElement> | null) => {
  const [height, setHeight] = useState(0);
  useResizeObserver(ref, (entry) => {
    // Return block size if it is available.
    if (entry.borderBoxSize.length > 0) {
      // borderBoxSize may have several items but we are only interesed in the first.
      setHeight(entry.borderBoxSize[0].blockSize);
    } else {
      setHeight(entry.contentRect.height);
    }
  });
  return height;
};
